import { render, staticRenderFns } from "./HomeworkAnswerManage.vue?vue&type=template&id=818a16f2&scoped=true"
import script from "./HomeworkAnswerManage.vue?vue&type=script&lang=js"
export * from "./HomeworkAnswerManage.vue?vue&type=script&lang=js"
import style0 from "./HomeworkAnswerManage.vue?vue&type=style&index=0&id=818a16f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818a16f2",
  null
  
)

export default component.exports